import { Component } from '@angular/core';
import { FormControl } from '@angular/forms';
import { SearchServiceProxy } from '@shared/service-proxies/service-proxies';
import { NgxSpinnerService } from 'ngx-spinner';
import { of } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, switchMap, tap } from 'rxjs/operators';
import { HeaderSearchInputDataFactoryService } from './header-search-input-data-factory.service';

@Component({
    selector: 'header-search-input',
    templateUrl: './header-search-input.component.html',
    styleUrls: ['./header-search-input.component.less'],
    providers: [HeaderSearchInputDataFactoryService],
})
export class HeaderSearchInputComponent {
    readonly filterTextControl = new FormControl();

    readonly searchResults$ = this.filterTextControl.valueChanges.pipe(
        map(searchText => searchText?.trim()),
        distinctUntilChanged(),
        debounceTime(500),
        switchMap(searchText => this.search(searchText)),
    );

    isOpened: boolean;

    constructor(
        private _headerSearchInputDataFactory: HeaderSearchInputDataFactoryService,
        private _spinnerService: NgxSpinnerService,
        private _searchServiceProxy: SearchServiceProxy,
    ) { }

    openMenu() {
        this.isOpened = true;
    }

    hideMenu() {
        this.isOpened = false;
    }

    private search(searchText: string) {
        if (searchText == null || !searchText.length) {
            return of(undefined);
        }

        this._spinnerService.show('search-input-loading');

        return this._searchServiceProxy.search(searchText).pipe(
            map(searchOutput => this._headerSearchInputDataFactory.mapOutput(searchOutput, searchText)),
            tap({ complete: () => this._spinnerService.hide('search-input-loading') }),
        );
    }
}
